import axios from 'axios';
import download from 'downloadjs';
import endpoints from '../../endpoints';
import {handleError, handleRawResponse, handleResponse} from './apiUtils';

export function getCatalog(params) {
    const url = endpoints.catalog;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getCatalogPricing(params) {
    const url = endpoints.catalogPricing;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getCatalogDeviceDetails(params) {
    const url = endpoints.catalogDeviceDetails;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getInvoiceId(invoiceNumber) {
    const url = endpoints.invoiceNumber(invoiceNumber);
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCatalogDeviceInfoByInvoiceId(invoiceId) {
    const url = endpoints.catalogDeviceInfo(invoiceId);
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getPriceTiers() {
    const url = endpoints.priceTiers;
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}
